<template>
  <v-row class="pl-2" dense align="center">
    <v-menu offset-y :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <v-btn small text outlined v-on="on" :attrs="attrs" color="primary"
          ><v-icon>mdi-filter</v-icon>Filters</v-btn
        >
      </template>
      <v-card max-width="1000px" style="overflow-y: auto">
        <v-card-text>
          <v-row dense>
            <v-col
              v-for="(item, index) in filtersList"
              :key="index"
              cols="12"
              sm="4"
            >
              <v-autocomplete
                v-if="!item.isDateField"
                :items="item.options"
                :value="item.value.id"
                item-value="id"
                @change="applyFilter(item.name, $event)"
                return-object
                clearable
                :label="item.label"
                hide-details
                dense
                outlined
                class="mx-1"
              ></v-autocomplete>
              <month-picker-field
                v-if="item.isDateField"
                :field="{ label: item.label }"
                :value="item.value"
                @fieldChange="applyDateFilter(item.name, $event)"
              ></month-picker-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-menu>
    <v-btn small text @click="clearFilters">Clear Filters</v-btn>
    <v-chip-group column>
      <template v-for="(filter, i) in appliedFilters">
        <v-chip
          :key="i"
          label
          close
          close-icon="mdi-close"
          @click:close="removeFilter(filter)"
          color="primary"
          dark
          small
          class="mx-1"
          >{{ filter.label }}: {{ filter.text }}</v-chip
        >
      </template>
    </v-chip-group>
  </v-row>
</template>

<script>
import { formatDate } from "../../utils/format-utils";
import MonthPickerField from "../FormFields/month-picker-field.vue";
export default {
  components: { MonthPickerField },
  mounted() {
    this.$emit("applyFilters", this.filteredRoster);
  },
  computed: {
    // filters
    filtersList() {
      return [
        {
          label: "Client",
          name: "clientFilter",
          value: this.filters.clientFilter || "",
          options: this.clientRoster
            .map((item) => {
              return {
                text: `${item.clientName} (${item.formattedDob})`,
                id: item.clientId,
              };
            })
            .sort((a, b) => a.text.localeCompare(b.text)),
        },
        {
          label: "Year Of Birth",
          name: "yearOfBirthFilter",
          value: this.filters.yearOfBirthFilter || "",
          options: this.clientRoster
            .map((item) => {
              return {
                text: `${item.yearOfBirth} DOB`,
                id: item.yearOfBirth,
              };
            })
            .sort((a, b) => a - b),
        },
        {
          label: "District",
          name: "districtFilter",
          value: this.filters.districtFilter || "",
          options: this.clientRoster
            .filter((item) => item.districtId != null)
            .map((item) => {
              return {
                text: item.districtId,
                id: item.districtId,
              };
            })
            .sort((a, b) => a - b),
        },
        {
          label: "District Admin",
          name: "districtAdminFilter",
          value: this.filters.districtAdminFilter || "",
          options: this.clientRoster
            .filter((item) => item.districtAdminId != null)
            .map((item) => {
              return {
                text: item.districtAdminFullName,
                id: item.districtAdminId,
              };
            })
            .sort((a, b) => a.text.localeCompare(b.text)),
        },
        {
          label: "School",
          name: "schoolFilter",
          value: this.filters.schoolFilter || "",
          options: this.clientRoster
            .filter((item) => item.schoolId != null)
            .map((item) => {
              return {
                text: item.schoolName,
                id: item.schoolId,
              };
            })
            .sort((a, b) => a.text.localeCompare(b.text)),
        },
        {
          label: "Team",
          name: "teamFilter",
          value: this.filters.teamFilter || "",
          options: this.clientRoster
            .filter((item) => item.teamId != null)
            .map((item) => {
              return {
                text: item.teamName,
                id: item.teamId,
              };
            })
            .sort((a, b) => a.text.localeCompare(b.text)),
        },
        {
          label: "Group Size",
          name: "groupSizeFilter",
          value: this.filters.groupSizeFilter || "",
          options: [
            { text: "1", id: 1 },
            { text: "2", id: 2 },
            { text: "3", id: 3 },
          ],
        },
        {
          label: "10/12 Month",
          name: "tenTwelveMonthFilter",
          value: this.filters.tenTwelveMonthFilter || "",
          options: [
            { text: "10-month", id: "10" },
            { text: "12-month", id: "12" },
          ],
        },
        {
          label: "Language",
          name: "languageFilter",
          value: this.filters.languageFilter || "",
          options: this.clientRoster
            .filter((item) => item.languageId != null)
            .map((item) => {
              return {
                text: item.language,
                id: item.languageId,
              };
            })
            .sort((a, b) => a.text.localeCompare(b.text)),
        },
        {
          label: "Location",
          name: "locationFilter",
          value: this.filters.locationFilter || "",
          options: this.clientRoster
            .filter((item) => item.locationId != null)
            .map((item) => {
              return {
                text: item.location,
                id: item.locationId,
              };
            })
            .sort((a, b) => a.text.localeCompare(b.text)),
        },
        {
          label: "Semester",
          name: "semesterFilter",
          value: this.filters.semesterFilter || "",
          options: this.clientRoster
            .filter((item) => item.semesterCode != null)
            .map((item) => {
              return {
                text: item.semesterCode,
                id: item.semesterCode,
              };
            })
            .sort((a, b) => a - b),
        },
        {
          label: "Provider",
          name: "providerFilter",
          value: this.filters.providerFilter || "",
          options: this.clientRoster
            .filter((item) => item.providerId != null)
            .map((item) => {
              return {
                text: `${item.providerFullName} - ${item.legacyProviderId}`,
                id: item.providerId,
              };
            })
            .sort((a, b) => a.text.localeCompare(b.text)),
        },
        {
          isDateField: true,
          label: "Plan Start",
          name: "planStartDateFilter",
          value: this.filters.planStartDateFilter.map((item) => item) || [],
        },
        {
          isDateField: true,
          label: "Plan End",
          name: "planEndDateFilter",
          value: this.filters.planEndDateFilter.map((item) => item) || [],
        },
        {
          isDateField: true,
          label: "FAD",
          name: "actualStartDateFilter",
          value: this.filters.actualStartDateFilter.map((item) => item) || [],
        },
      ];
    },
    clientRoster() {
      return this.$store.state.plansModule.clientRoster || [];
    },
    filters() {
      return this.$store.state.plansModule.filters;
    },
    activePlansFilter() {
      return this.filters.activePlansFilter;
    },
    appliedFilters() {
      return this.filtersList
        .filter(
          (item) =>
            (Array.isArray(item.value) && item.value.length > 0) ||
            Object.keys(item.value).length > 0
        )
        .map((item) => {
          return {
            ...item,
            text:
              item.value.text || item.value.map((item) => item.text).join(","),
          };
        });
    },
    filteredRoster() {
      return this.clientRoster.filter((x) => {
        return (
          (!Boolean(this.filters.clientFilter.id) ||
            x.clientId == this.filters.clientFilter.id) &&
          (!Boolean(this.filters.yearOfBirthFilter.id) ||
            x.yearOfBirth == this.filters.yearOfBirthFilter.id) &&
          (!Boolean(this.filters.districtFilter.id) ||
            x.districtId == this.filters.districtFilter.id) &&
          (!Boolean(this.filters.districtAdminFilter.id) ||
            x.districtAdminId == this.filters.districtAdminFilter.id) &&
          (!Boolean(this.filters.schoolFilter.id) ||
            x.schoolId == this.filters.schoolFilter.id) &&
          (!Boolean(this.filters.teamFilter.id) ||
            x.teamId == this.filters.teamFilter.id) &&
          (!Boolean(this.filters.groupSizeFilter.id) ||
            x.groupSize == this.filters.groupSizeFilter.id) &&
          (!Boolean(this.filters.tenTwelveMonthFilter.id) ||
            x.tenTwelveMonth === this.filters.tenTwelveMonthFilter.id) &&
          (!Boolean(this.filters.languageFilter.id) ||
            x.languageId == this.filters.languageFilter.id) &&
          (!Boolean(this.filters.locationFilter.id) ||
            x.locationId == this.filters.locationFilter.id) &&
          (!Boolean(this.filters.semesterFilter.id) ||
            x.semesterCode == this.filters.semesterFilter.id) &&
          (!Boolean(this.filters.providerFilter.id) ||
            x.providerId == this.filters.providerFilter.id) &&
          // date filters
          (!Boolean(this.filters.planStartDateFilter.length) ||
            this.filters.planStartDateFilter.some((item) => {
              return (
                new Date(x.servicePlanStartDate).getMonth() ==
                  item.id.getMonth() &&
                new Date(x.servicePlanStartDate).getFullYear() ==
                  item.id.getFullYear()
              );
            })) &&
          (!Boolean(this.filters.planEndDateFilter.length) ||
            this.filters.planEndDateFilter.some((item) => {
              return (
                new Date(x.servicePlanEndDate).getMonth() ==
                  item.id.getMonth() &&
                new Date(x.servicePlanEndDate).getFullYear() ==
                  item.id.getFullYear()
              );
            })) &&
          (!Boolean(this.filters.actualStartDateFilter.length) ||
            this.filters.actualStartDateFilter.some((item) => {
              return (
                new Date(x.actualStartDate).getMonth() == item.id.getMonth() &&
                new Date(x.actualStartDate).getFullYear() ==
                  item.id.getFullYear()
              );
            })) &&
          (this.activePlansFilter === false || x.isActivePlan)
        );
      });
    },
  },
  methods: {
    formatDate,
    applyDateFilter(name, value) {
      this.applyFilter(
        name,
        value.map((item) => {
          return {
            id: item,
            text: `${item.toLocaleString("default", {
              month: "short",
            })} ${item.getFullYear()}`,
          };
        })
      );
    },
    applyFilter(name, value) {
      // save the value in the store
      this.$store.dispatch("plansModule/setFilters", {
        filterName: name,
        filterValue: value,
      });
      // emit event with filtered roster (for table)
      this.$emit("applyFilters", this.filteredRoster);
    },
    removeFilter(filter) {
      if (filter.isDateField) {
        this.applyFilter(filter.name, []);
      } else {
        this.applyFilter(filter.name, {});
      }
    },
    clearFilters() {
      this.$store.dispatch("plansModule/clearFilters");
      this.$emit("applyFilters", this.filteredRoster);
    },
  },
  watch: {
    clientRoster() {
      this.$emit("applyFilters", this.filteredRoster);
    },
    activePlansFilter() {
      this.$emit("applyFilters", this.filteredRoster);
    },
  },
};
</script>
